import { PER_PAGE_TYPES } from "enums";
import { ItemSearchOptions } from "models";
import React, { useEffect } from "react";

type PROPS = {
  options: ItemSearchOptions;
  onChange: () => void;
};

const RowsPerPageSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string | number>("");

  useEffect(() => {
    setSortOrder(props.options.get_count ?? "");
  }, [props.options.get_count]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer "
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        props.options.get_count = value;
        setSortOrder(value);
        props.onChange();
      }}
    >
      <option value={PER_PAGE_TYPES._10}>10件</option>
      <option value={PER_PAGE_TYPES._25}>25件</option>
      <option value={PER_PAGE_TYPES._50}>50件</option>
      <option value={PER_PAGE_TYPES._100}>100件</option>
    </select>
  );
};

export default RowsPerPageSelect;
